import * as React from 'react'
import {connect} from 'react-redux'
import {Col, Navbar, NavbarBrand, Row} from 'reactstrap'
import {Footer} from '../footer'
import * as RasaMenu from '../menu'
import * as LeftNav from '../menu/left-nav'
import './styles.css'

export const visibleOnDesktop = 'd-none d-md-block'
export const visibleSmall = 'd-block d-sm-block d-md-none'

export const LayoutComponent = ({children}: any) =>
<div>
  <RasaMenu.RasaMenu />
  <div className="content-area">
    <Row className="content-row">
      <Col sm="3" lg="2" className={`${visibleOnDesktop}`} >
        <LeftNav.LeftNavConnected />
      </Col>
      <Col className={`${visibleSmall} mobile-padding`} >
        <LeftNav.MobileNavConnected />
      </Col>
      <Col sm="12" md="9" lg="10">
        {children}
      </Col>
    </Row>
  </div>
  <Footer />
</div>

export const HeaderOnlyLayoutComponent = ({children}: any) =>
<div>
  <RasaMenu.RasaMenu />
  <div className="content-area">
    <Row className="content-row">
      <Col sm="12">
        {children}
      </Col>
    </Row>
  </div>
  <Footer />
</div>

export const PureLayout = ({children}: any) => <div>
  <Navbar className="rasa-menu" expand>
    <NavbarBrand href="/">
      <img src="https://image-api.rasa.io/image/rasa-templates/path/rasa/logo_simplified.png?h=30" />
    </NavbarBrand>
  </Navbar>
  <div className="content-area">
    <Row className="content-row">
      <Col md="12">
        {children}
      </Col>
    </Row>
  </div>
  <Footer />
</div>

export const Layout = connect()(LayoutComponent)

export const HeaderOnlyLayout = connect()(HeaderOnlyLayoutComponent)



// WEBPACK FOOTER //
// ./src/components/layout/component.tsx